// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__layout,#__nuxt{width:100%;height:99%;overflow:hidden;position:fixed}.print_layout #__layout,.print_layout #__nuxt{width:auto;height:auto;overflow:static;position:relative}@media print{.noprint{display:none}#__layout,#__nuxt,body,html{width:auto;height:auto;overflow:static;position:relative}}.break{flex-basis:100%;height:0}.hidescrollbar::-webkit-scrollbar{width:0!important}.hidescrollbar{overflow:-moz-scrollbars-none;-ms-overflow-style:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
